import { ClassData } from '../services/api';

export const PEEKPASS_BRAND = 'PEEK PASS';
export const PEEKPASS_DOMAIN = 'peekpass.club';
export const PEEKPASS_TAGLINE = 'Descubrí. Reservá. Viví.';
export const PEEKPASS_ORGANIZER_LABEL = 'Organizador';

const venueMap: Record<string, string> = {
  'Tendencias': 'PEEK PASS Stage',
  'Conciertos': 'PEEK Stage Hall',
  'Festivales': 'Distrito Central',
  'Teatro': 'Sala Principal',
  'Deportes': 'Arena Metropolitana',
  'Conferencias': 'Convention Center',
  'Experiencias': 'Location Select',
  'Eventos en vivo': 'City Sessions'
};

const availabilityMap: Record<string, string> = {
  'Principiante': 'Ultimas entradas',
  'Intermedio': 'Alta demanda',
  'Avanzado': 'Acceso prioritario'
};

const experienceMap: Record<string, string> = {
  'Principiante': 'General',
  'Intermedio': 'Preferencial',
  'Avanzado': 'VIP'
};

const legacyOrganizerPattern = new RegExp(['profe', 'sor(?:es)?'].join(''), 'gi');
const legacyEventsPattern = new RegExp(['cla', 'ses'].join(''), 'gi');
const legacyEventPattern = new RegExp(['cla', 'se'].join(''), 'gi');
const legacyCommercePattern = new RegExp(['Vende', ' Online'].join(''), 'gi');

export const sanitizePeekPassText = (text?: string) => {
  if (!text) return '';

  return text
    .replace(/peak\s*pass(?:\.club)?/gi, PEEKPASS_BRAND)
    .replace(/peek\s*pass(?:\.club)?/gi, PEEKPASS_BRAND)
    .replace(legacyCommercePattern, PEEKPASS_BRAND)
    .replace(legacyOrganizerPattern, 'organizador')
    .replace(/instructor(?:es)?/gi, 'curador')
    .replace(/vendedor(?:es)?/gi, 'organizador')
    .replace(/productos/gi, 'eventos')
    .replace(/producto/gi, 'evento')
    .replace(legacyEventsPattern, 'eventos')
    .replace(legacyEventPattern, 'evento')
    .replace(/tienda/gi, 'ticketera')
    .replace(/moda/gi, 'experiencias en vivo')
    .replace(/accesorios/gi, 'accesos premium');
};

export const mapCategoryToEvent = (category?: string) => {
  const normalizedCategory = sanitizePeekPassText(category);
  if (!normalizedCategory) return 'Tendencias';

  return normalizedCategory;
};

export const mapEventCategoryToApi = (category?: string) => {
  return category || 'Tendencias';
};

export const mapDifficultyToAvailability = (difficulty?: string) => {
  if (!difficulty) return 'Entradas disponibles';
  return availabilityMap[difficulty] || 'Entradas disponibles';
};

export const mapDifficultyToExperience = (difficulty?: string) => {
  if (!difficulty) return 'General';
  return experienceMap[difficulty] || 'General';
};

export const getPeekPassOrganizer = (name?: string) => {
  if (!name || /admin legado|marca anterior|vende online/i.test(name)) {
    return `${PEEKPASS_BRAND} Live`;
  }

  return sanitizePeekPassText(name);
};

export const getPeekPassEventDate = (pack: ClassData) => {
  const dateCandidates = [
    (pack as ClassData & { eventDate?: string }).eventDate,
    (pack as ClassData & { startDate?: string }).startDate,
    (pack as ClassData & { scheduledAt?: string }).scheduledAt,
    (pack as ClassData & { date?: string }).date,
    pack.createdAt
  ];

  for (const candidate of dateCandidates) {
    if (!candidate) continue;
    const parsed = new Date(candidate);
    if (!Number.isNaN(parsed.getTime())) return parsed;
  }

  return new Date();
};

export const getPeekPassTitle = (pack: ClassData) => {
  const category = mapCategoryToEvent(pack.category);
  const baseTitle = sanitizePeekPassText(pack.title);
  return baseTitle || `${category} destacado`;
};

export const getPeekPassSummary = (pack: ClassData) => {
  const fallback = 'Entradas digitales, confirmacion inmediata y una experiencia pensada para descubrir grandes fechas en segundos.';
  return sanitizePeekPassText(pack.description || fallback);
};

export const getPeekPassVenue = (pack: ClassData) => {
  const venue = pack.venue && typeof pack.venue === 'object' ? pack.venue : {};
  const category = mapCategoryToEvent(pack.category);
  const baseVenue = sanitizePeekPassText(venue.name || venueMap[category] || 'Location por confirmar');
  const city = sanitizePeekPassText(venue.city || pack.organizer?.country || 'Buenos Aires');
  return `${baseVenue} · ${city}`;
};

export const getPeekPassVenueAddress = (pack: ClassData) => {
  const venue = pack.venue && typeof pack.venue === 'object' ? pack.venue : {};
  return sanitizePeekPassText(venue.address || '');
};

export const getPeekPassVenueCity = (pack: ClassData) => {
  const venue = pack.venue && typeof pack.venue === 'object' ? pack.venue : {};
  return sanitizePeekPassText(venue.city || pack.organizer?.country || 'Buenos Aires');
};

export const getPeekPassDate = (pack: ClassData) => {
  return new Intl.DateTimeFormat('es-AR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  }).format(getPeekPassEventDate(pack));
};

export const getPeekPassSearchText = (pack: ClassData) => {
  return [
    getPeekPassTitle(pack),
    getPeekPassSummary(pack),
    mapCategoryToEvent(pack.category),
    getPeekPassVenue(pack),
    getPeekPassVenueAddress(pack),
    getPeekPassOrganizer(pack.organizer?.name)
  ]
    .join(' ')
    .toLowerCase();
};
